const { REACT_APP_BASE_URL: BASE_API_URL } = process.env;

// url for get all notes by leadId
export const GET_POST_LOCATIONS = `${BASE_API_URL}/leads/sub_organizations/:subOrgId/manage-locations/`;
export const UPDATE_DELETE_LOCATIONS = `${BASE_API_URL}/leads/sub_organizations/:subOrgId/manage-locations/:locationId/`;
export const UPDATE_LABEL_LOCATION_STATUS = `${BASE_API_URL}/organization/sub_organizations/:subOrgId/manage_locations_labels`;
export const UPDATE_LABEL_LOCATION_LEAD_STATUS = `${BASE_API_URL}/leads/sub_organizations/:leadId/map-lead-location`;
